import { isNotProd } from "./util";
import{commonAjaxCallfunctionHidingMenu} from "./commonAjaxCallfunctionHidingMenu";
jQuery.expr[':'].contains = function(a:any, i:any, m:any) {
    return jQuery(a).text().toUpperCase()
        .indexOf(m[3].toUpperCase()) >= 0;
  };
export function hidingMttMenuLink()
{
    let franchiseId: any = $("#franchiseId").val();
    let webLocationId:any = $("#weblocationId").val() ? $("#weblocationId").val() : localStorage.getItem("localWebLocationId");
    let apiDomain1 = isNotProd() ? window.DEFINE_VALUE.JS_API_URL : "https://api.neighborly.com";
    let apiKey1 = isNotProd() ? window.DEFINE_VALUE.JS_API_KEY : "pneiweb-9pbaOywNKQj853D";
    let franchiseemployeeorchestrations = isNotProd() ? window.DEFINE_VALUE.JS_EmployeeOrchestrations_URL : "franchiseemployeeorchestrations-api";
    let meetTheTeam = `${apiDomain1}/${franchiseemployeeorchestrations}/v1/public/MeetTheTeam/FranchiseWebLocationId/`;
    let apiUrl = meetTheTeam + webLocationId + '?apikey=' + apiKey1;
    
    commonAjaxCallfunctionHidingMenu(apiUrl,'', function (data: any)
    {
        if(data){
        const teamSize = data.teamSize;
        const employeePhotoInfo = data.employeePhotoInfo;
        const staffPhotoInfo = data.staffPhotoInfo;

        const isEmptyArray = (value: any): boolean =>
            Array.isArray(value) && value.length === 0;
        
        const isEmptyObject = (value: any): boolean =>
            typeof value === 'object' && !Array.isArray(value) && value !== null && Object.keys(value).length === 0;
        
        const isMissingOrEmpty = (value: any): boolean =>
            value === null || value === undefined || isEmptyArray(value) || isEmptyObject(value);

        const isMissingDisplayName = (value: string | null | undefined): boolean =>
            value === null || value === undefined || value.trim() === '';
        
        const normalizeToArray = (value: any): any[] => {
            if (value === null || value === undefined) return [];
            if (Array.isArray(value)) return value;
            return value && typeof value === 'object' ? [value] : [];
            };

            const hasValidNameOrDisplayName = (items: any[]): boolean =>
                items.some(item => {
                const detail = item?.franchiseProfileEmployeeBioDetail || item;
                return (
                detail !== null &&
                detail !== undefined &&
                (!isMissingDisplayName(detail?.name) || !isMissingDisplayName(detail?.displayName))
                );
                });

        const employeeArray = normalizeToArray(employeePhotoInfo);
        const staffArray = normalizeToArray(staffPhotoInfo);

        if (
            !teamSize ||
            (
                (isMissingOrEmpty(employeePhotoInfo) || !hasValidNameOrDisplayName(employeeArray)) &&
                (isMissingOrEmpty(staffPhotoInfo) || !hasValidNameOrDisplayName(staffArray))
            )
        ) 
        {
            $('.dropdown-item:contains("meet the team")').hide();
            $('.dropdown-link:contains("meet the team")').hide();

            if($('#conceptCode').val()==='MHM' || $('#conceptCode').val()==='HMC')
            {
                $('.dropdown-item:contains("our team")').hide();
                $('.dropdown-link:contains("our team")').hide();
            }
        }
        else
        {
            $('.dropdown-item:contains("meet the team")').show();
            $('.dropdown-link:contains("meet the team")').show();

            if($('#conceptCode').val()==='MHM' || $('#conceptCode').val()==='HMC')
            {
                $('.dropdown-item:contains("our team")').show();
                $('.dropdown-link:contains("our team")').show();
            }
        }
        } else {
            $('.dropdown-item:contains("meet the team")').hide();
            $('.dropdown-link:contains("meet the team")').hide();

            if($('#conceptCode').val()==='MHM' || $('#conceptCode').val()==='HMC')
            {
                $('.dropdown-item:contains("our team")').hide();
                $('.dropdown-link:contains("our team")').hide();
            }
        }
    });
}